import { Skeleton } from '@aspid/ui';
import { Box } from '@mui/material';


import { palette } from '@app/theme';

import type { SpreadSheetSkeletonProperties } from './SpreadSheetSkeleton.types';

const HEADER_HEIGHT = 32;
const ROW_HEIGHT = 28;
const BORDER_COLOR = palette.border.default;
const SECTION_ROWS = new Set([0, 5, 12]);

export const SpreadSheetSkeleton = ({
  columns = 5,
  rows = 15,
  dataTest = 'spread_sheet_skeleton',
}: SpreadSheetSkeletonProperties) => {
  return (
    <Box
      data-testid={dataTest}
      sx={{
        width: '100%',
        border: `1px solid ${BORDER_COLOR}`,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: HEADER_HEIGHT,
          borderBottom: `1px solid ${BORDER_COLOR}`,
          backgroundColor: palette.background.default,
          alignItems: 'center'
        }}>
        <Box sx={{ width: '35%', px: 1.5 }}>
          <Skeleton width='40%' height={11} />
        </Box>
        {Array.from({ length: columns }, (_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              px: 1,
              borderLeft: `1px solid ${BORDER_COLOR}`,
            }}
          >
            <Skeleton width='60%' height={11} />
          </Box>
        ))}
      </Box>
      {Array.from({ length: rows }, (_, rowIndex) => {
        const isSection = SECTION_ROWS.has(rowIndex);
        return (
          <Box
            key={rowIndex}
            sx={{
              display: 'flex',
              height: ROW_HEIGHT,
              borderBottom: `1px solid ${BORDER_COLOR}`,
              alignItems: 'center',
              backgroundColor: isSection ? palette.background.default : 'transparent'
            }}>
            <Box sx={{ width: '35%', px: 1.5 }}>
              <Skeleton
                width={isSection ? '50%' : '65%'}
                height={isSection ? 12 : 10}
              />
            </Box>
            {Array.from({ length: columns }, (_, colIndex) => (
              <Box
                key={colIndex}
                sx={{
                  flex: 1,
                  px: 1,
                  borderLeft: `1px solid ${BORDER_COLOR}`,
                }}
              >
                {!isSection && <Skeleton width='50%' height={10} />}
              </Box>
            ))}
          </Box>
        );
      })}
    </Box>
  );
};
